import React from "react";

const ASPECT_CLASS = {
  "4x3": "landing-v2-placeholder--4x3",
  "16x9": "landing-v2-placeholder--16x9",
};

const MediaPlaceholder = ({
  label,
  src,
  alt,
  caption,
  videoSrc,
  videoAutoPlay = false,
  videoLoop = false,
  videoControls = true,
  aspectRatio = "16x9",
  className = "",
}) => {
  const aspectClass = ASPECT_CLASS[aspectRatio] ?? ASPECT_CLASS["16x9"];

  if (videoSrc) {
    return (
      <div className={`landing-v2-media ${aspectClass} ${className}`.trim()}>
        <video
          className="landing-v2-media__video"
          src={videoSrc}
          controls={videoControls}
          autoPlay={videoAutoPlay}
          loop={videoLoop}
          muted={videoAutoPlay}
          playsInline
          preload={videoAutoPlay ? "auto" : "metadata"}
          aria-label={alt || label}
        />
      </div>
    );
  }

  if (src) {
    return (
      <figure className={`landing-v2-media ${aspectClass} ${className}`.trim()}>
        <img
          src={src}
          alt={alt || label}
          className="landing-v2-media__img"
          loading="lazy"
          decoding="async"
        />
        {caption ? <figcaption className="landing-v2-media__caption">{caption}</figcaption> : null}
      </figure>
    );
  }

  return (
    <div
      className={`landing-v2-placeholder ${aspectClass} ${className}`.trim()}
      role="img"
      aria-label={label}
    >
      <p className="landing-v2-placeholder__label">{label}</p>
    </div>
  );
};

export default MediaPlaceholder;
